import { LONG, SHORT } from "lib/legacy";
import { useLocalStorageByChainId } from "lib/localStorage";

export const useSwapOption = (chainId: number) => {
  const [swapOption, setSwapOption] = useLocalStorageByChainId(chainId, "Swap-option-v2", LONG);

  return [swapOption, setSwapOption];
};

export const useSwapOptionParser = (swapOption: string | undefined) => {
  const isLong = swapOption === LONG;
  const isShort = swapOption === SHORT;

  return {
    isLong,
    isShort,
  };
};
